<template>
  <div>
    <div class="r-text-intro">
      היי {{this.firstName}}, שמחים שחזרת!
    </div>
    <div class="r-text-headline-paragraph">
      ׳מיטב׳ מטפלת בפתיחת הקופה שלך,
      זה לוקח קצת יותר משבוע.
    </div>

    <div class="r-text-intro">
      מה עכשיו?
    </div>
    <div class="r-text-headline-paragraph">
      ברגע שהקופה תפתח יגיע מייל נוסף עם לינק לאזור האישי.
    </div>

    <div class="r-text-headline-paragraph">
      אם תהיה בעיה, הם יתקשרו.
    </div>

    <div class="r-text-headline-paragraph">
      <div>בינתיים,</div>
      <div>בכל בקשה או שאלה -</div>
      <div>אפשר לפנות אלינו:</div>
      <link-button text="saving@riseup.co.il" @click="sendMailTo('saving@riseup.co.il')"/>
    </div>
  </div>
</template>

<script>
import TrackedPage from '@/mixins/TrackedPage';
import { mapState } from 'vuex';
import ScrollToTop from '@/mixins/ScrollToTop';
import LinkButton from '@/components/base/LinkButton';
import ExternalPagesActions from '@/mixins/ExternalPagesActions';

export default {
  name: 'FundSubmitted',
  mixins: [TrackedPage, ScrollToTop, ExternalPagesActions],
  components: { LinkButton },
  computed: {
    ...mapState('meitavDash/openFund', ['firstName']),
  },
};
</script>
